import React from "react";
import { RaisedButton } from "material-ui";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import BallotStore from "../stores/BallotStore";
import BallotActions from "../actions/BallotActions";
import UserStore from "../stores/UserStore";

import LinkLike from "./partials/link-like.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import SelectWells from "./partials/select-wells.jsx";

import BallotIcon from "./partials/icons/ballot.jsx";
import PrintIcon from "material-ui/svg-icons/action/print";
import TouchAppIcon from "material-ui/svg-icons/action/touch-app";
import HowToVoteIcon from "./partials/icons/how-to-vote.jsx";
import WhereToVoteIcon from "./partials/icons/where-to-vote.jsx";

class Balloting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasInjectedSettings: false,
      settings: {}
    };

    this.updateSetting = this.updateSetting.bind(this);
  }

  static getStores() {
    return [EventBucketStore, BallotStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getEventBucketById: EventBucketStore.getEventBucketById,
      getStatsForEventBucket: BallotStore.getStatsForEventBucket,
      getVotesForEvent: BallotStore.getVotesForEvent,
      getTabulationsForEventBucket: BallotStore.getTabulationsForEventBucket,
      isWorking: BallotStore.getState().isWorking
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  updateSetting(key, value) {
    let settings = Object.assign({}, this.state.settings);
    settings[key] = value;

    if (key === "online_ballot_custom_introduction_tags") {
      settings.online_ballot_custom_introduction_by_tagging_modal_headers = settings.online_ballot_custom_introduction_by_tagging_modal_headers || {};

      for (const k of value) {
        settings.online_ballot_custom_introduction_by_tagging_modal_headers[k] = typeof settings.online_ballot_custom_introduction_by_tagging_modal_headers[k] === "undefined" ? "" : settings.online_ballot_custom_introduction_by_tagging_modal_headers[k]
      }
    }

    this.setState({ settings });

    // Persist
    EventBucketActions.edit(this.props.params.eventBucketId, {
      balloting_config: settings
    });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
    BallotActions.fetchStats.defer(this.props.params.eventBucketId);
  }

  componentWillReceiveProps(props) {
    let bucket = this.props.getEventBucketById(props.params.eventBucketId),
      canInject = bucket && bucket.balloting_config;

    if (canInject && !this.state.hasInjectedSettings) {
      this.setState({
        hasInjectedSettings: true,
        settings: bucket.balloting_config
      });
    }
  }

  getStyles() {
    return {
      header: {
        textAlign: "center",
        marginBottom: "1em"
      },
      body: {
        textAlign: "center"
      },
      intro: {
        color: "rgb(33,33,33)",
        textAlign: "center"
      },
      childen: {
        textAlign: "left",
        fontSize: "12pt"
      }
    };
  }

  render() {
    const { eventBucketId } = this.props.params,
      eventBucket = this.props.getEventBucketById(eventBucketId),
      ballotStats = this.props.getStatsForEventBucket(eventBucketId),
      ballotTabulations = this.props.getTabulationsForEventBucket(
        eventBucketId
      ),
      styles = this.getStyles();

    if (!eventBucket || !this.state.hasInjectedSettings) {
      return <WorkingIndicator fullPage={true} />;
    }

    let showWells = true;
    if (
      UserStore.hasPermission("app_balloting") &&
      !UserStore.hasPermission("print_balloting")
    ) {
      showWells = false;
    }

    let ballotingWells = []
      .concat(
        UserStore.hasPermission("manage_balloting") ||
          UserStore.hasPermission("setup_balloting")
          ? [
              {
                value: "setup",
                icon: BallotIcon,
                label: "Set up ballots"
              }
            ]
          : []
      )
      .concat(
        UserStore.hasPermission("manage_balloting") ||
          UserStore.hasPermission("app_balloting")
          ? [
              {
                value: "app",
                icon: TouchAppIcon,
                label: "Mobile ballots"
              }
            ]
          : []
      )
      .concat(
        UserStore.hasPermission("manage_balloting") ||
          UserStore.hasPermission("print_balloting")
          ? [
              {
                value: "print",
                icon: PrintIcon,
                label: "Print ballots"
              }
            ]
          : []
      )
      .concat(
        UserStore.hasPermission("manage_balloting") ||
          UserStore.hasPermission("record_balloting")
          ? [
              {
                value: "record",
                icon: HowToVoteIcon,
                label: "Record votes"
              }
            ]
          : []
      )
      .concat(
        UserStore.hasPermission("manage_balloting") ||
          UserStore.hasPermission("tabulate_balloting")
          ? [
              {
                value: "tabulate",
                icon: WhereToVoteIcon,
                label: "Tabulate results"
              }
            ]
          : []
      );

    return (
      <div>
        <h1 style={styles.header}>{eventBucket.name} Balloting</h1>
        <div style={styles.body}>
          {showWells ? (
            <SelectWells
              style={{ margin: "1em -0.5em", fontSize: "0.8vw" }}
              options={ballotingWells}
              onChange={v =>
                this.context.router.push(
                  `/event_buckets/${eventBucket.id}/balloting/${v}`
                )
              }
              value={this.props.location.pathname.split("/").pop()}
            />
          ) : null}
          <div style={styles.childen}>
            {this.props.children ? (
              React.cloneElement(this.props.children, {
                eventBucket: eventBucket,
                settings: this.state.settings,
                updateSetting: this.updateSetting,
                ballotStats: ballotStats,
                ballotTabulations: ballotTabulations,
                getVotesForEvent: this.props.getVotesForEvent,
                isWorking: this.props.isWorking
              })
            ) : (
              <p style={styles.intro}>
                Use Eventive Balloting to automatically generate and tabulate
                ballots for your events. Begin by selecting an option above.
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connectToStores(Balloting);



// WEBPACK FOOTER //
// ./src/app/components/balloting.jsx